'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _HeaderMainLinkDropdown = require('./HeaderMainLinkDropdown');var _HeaderMainLinkDropdown2 = _interopRequireDefault(_HeaderMainLinkDropdown);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _ = require('../../');
var _constants = require('../../../constants');

var _HeaderDesktop = require('../HeaderDesktop.scss');var styles = _interopRequireWildcard(_HeaderDesktop);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var checkIsActiveLink = function checkIsActiveLink(location, option, routeData) {
  var postfix = option ? '/' + option : '';var _ref =
  routeData || {},route = _ref.route;

  return route.includes('' + location + postfix);
};var

HeaderMainLink = function (_Component) {_inherits(HeaderMainLink, _Component);function HeaderMainLink() {var _temp, _this, _ret;_classCallCheck(this, HeaderMainLink);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      openDropdown: false }, _this.


    openDropdown = function () {return _this.setState({ openDropdown: true });}, _this.
    closeDropdown = function () {return _this.setState({ openDropdown: false });}, _temp), _possibleConstructorReturn(_this, _ret);}HeaderMainLink.prototype.

  render = function render() {var _cx;var _props =












    this.props,id = _props.id,main = _props.main,name = _props.name,isNew = _props.isNew,option = _props.option,locale = _props.locale,onClick = _props.onClick,location = _props.location,routeData = _props.routeData,translate = _props.translate,_props$options = _props.options,options = _props$options === undefined ? {} : _props$options;

    return (
      _react2.default.createElement('div', {
          onMouseEnter: this.openDropdown,
          onMouseLeave: this.closeDropdown,
          onClick: this.closeDropdown,
          className: styles.row },

        _react2.default.createElement(_reactRouter.Link, _extends({
            'data-link-id': id,
            key: '/' + location + (option ? '/' + option : ''),
            className: (0, _classnames2.default)(
            styles.mainLink, (_cx = {}, _cx[
            styles.active] = checkIsActiveLink(location, option, routeData), _cx)),

            to: {
              pathname: (0, _appendLocale2.default)(locale, '/' + location + (option ? '/' + option : '')),
              state: routeData.location === _constants.ROUTES_PATHS.FOREIGN ? undefined : Object.assign({},
              routeData, {
                favorites: false,
                optionType: option,
                location: location },
              options) } },


          { onClick: onClick }),

          name,
          isNew ?

          _react2.default.createElement('span', null, '\xA0\xA0',
            _react2.default.createElement(_.OMLabelNew, {
              label: translate('iconTitles', 'newPropertyLabel'),
              color: '#FF8479' })) :



          null),


        this.state.openDropdown &&
        _react2.default.createElement(_HeaderMainLinkDropdown2.default, {
          checkIsActiveLink: checkIsActiveLink,
          closeDropdown: this.closeDropdown,
          translate: translate,
          routeData: routeData,
          location: location,
          options: options,
          locale: locale,
          option: option,
          main: main })));




  };return HeaderMainLink;}(_react.Component);exports.default = HeaderMainLink;


HeaderMainLink.propTypes = {
  id: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  location: _propTypes2.default.string,
  option: _propTypes2.default.string,
  name: _propTypes2.default.string,
  options: _propTypes2.default.object,
  route: _propTypes2.default.string,
  routeData: _propTypes2.default.object,
  main: _propTypes2.default.string,
  isNew: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderDesktop/components/MainLink.js
// module id = 2673
// module chunks = 0